import React from "react"
import * as style from "./tag.module.css"

const Tag = ({ categoryStyle, category }) => {
    return (
        <span className={`${style.tag} ${categoryStyle}`}>{category}</span>
    )
};

export default Tag
